<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-dialog 
            v-model="handleDialog" 
            width="1200" 
        >
            <v-card color="#F4FEFB">
                <v-card-title 
                    class="justify-center text-h5"
                >
                    グループ{{ formTitle }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" xl="3">
                                <badge-component tile content="必　須" color="red">
                                    <label-component>グループ名</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                    <v-text-field 
                                        v-model="groupName" 
                                        background-color="white"
                                        clearable
                                        outlined 
                                        v-disabled-icon-focus
                                        :maxlength="255"
                                        :error-messages="errors" 
                                    ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" xl="3">
                                グループメンバーの新規送信時、承認者を必須とする
                            </v-col>
                            <v-col cols="12" xl="7">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <v-switch
                                        v-model="needsApproval"
                                        :label="needsApproval ? 'ON' : 'OFF'"
                                    ></v-switch>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                
                <v-divider></v-divider>
                
                <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn 
                        min-width="150px" 
                        class="white--text" 
                        color="red" 
                        large
                        :disabled="invalid"
                        @click="id ? save() : add()"
                    >
                        保存
                    </v-btn>
                    <v-btn 
                        min-width="150px" 
                        class="white--text" 
                        color="blue-grey lighten-1" 
                        large 
                        @click="handleDialog = false"
                    >
                        キャンセル
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            dialogItem: this.item
        };
    },
    computed: {
        formTitle () {
            return this.dialogItem.id ? '詳細' : '追加';
        },
        handleDialog: {
            get() {
                return this.dialog;
            },
            set(value) {
                this.$emit('update:dialog', value);
            }
        },
        id: {
            get() {
                return this.dialogItem.id;
            },
            set(value) {
                this.dialogItem.id = value;
            }
        },
        groupName: {
            get() {
                return this.dialogItem.name;
            },
            set(value) {
                this.dialogItem.name = value;
            }
        },
        needsApproval: {
            get() {
                return this.dialogItem.needs_approval?? false;
            },
            set(value) {
                this.dialogItem.needs_approval = value;
            }
        },
    },
    methods: {
        save: function () {
            axios.post(
                '/documents/update-organizations/' + this.id,
                {
                    'name': this.groupName,
                    'needs_approval': this.needsApproval,
                }
            ).then(res => {
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
                this.$emit("error", "処理に失敗しました");
            }).finally(() => {
            });
        },
        add: function () {
            axios.post(
                '/documents/add-organizations',
                {
                    'name': this.groupName,
                    'needs_approval': this.needsApproval,
                }
            ).then(res => {
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
                this.$emit("error", "処理に失敗しました");
            }).finally(() => {
            });
        }
    },
    props: {
        item: {},
        dialog: Boolean,
    },
};
</script>